export const FieldEditorService = Symbol('FieldEditorService');
